function SprintDetails({ sprint, closeModal }) {

    const getSprintDate = (date) => {
        return `${date.toDate().getDate()}/${date.toDate().getMonth()}/${date.toDate().getFullYear()}`;
    }

    return (
        <div className="block fixed z-[1] w-full h-full overflow-auto bg-[rgba(0,0,0,0.649)] left-0 top-0">
            <div className="flex justify-center items-center mt-[35vh] ml-[40vh]">
                <div className="text-[#ffffff] w-4/12 h-auto bg-[#3D3E44] rounded-xl ">
                    {/* Header for Form */}
                    <div className="bg-[#9B9B9B] rounded-t-xl py-3 text-3xl text-center">
                        Sprint Details
                    </div>

                    {/* Form Body */}
                    <div className="bg-[#3D3E44] rounded-b-xl">
                        <div>
                            {/* Sprint Name */}
                            <div className="mt-4 flex">
                                <div className="pl-10 text-xl">Name</div>
                                <div className="bg-[#616675] ml-3 mr-7 pl-3 rounded w-full text-xl">
                                    {sprint.sprintName}
                                </div>
                            </div>

                            {/* Sprint Start & End Date */}
                            <div className="mt-4 flex">
                                <div className="flex-1 flex">
                                    <div className="pl-2 text-xl">Start Date</div>
                                    <div className="bg-[#616675] rounded ml-1 flex-grow mr-2 pl-2 text-xl">
                                        {getSprintDate(sprint.sprintStartDate)}
                                    </div>
                                </div>

                                <div className="flex-1 flex">
                                    <div className="text-xl">End Date</div>
                                    <div className="bg-[#616675] rounded ml-3 flex-grow mr-7 pl-2 text-xl">
                                        {getSprintDate(sprint.sprintEndDate)}
                                    </div>
                                </div>
                            </div>

                            {/* Sprint Status */}
                            <div className="mt-4 flex">
                                <div className="pl-9 text-xl">Status</div>
                                <div className="bg-[#616675] ml-3 pl-2 w-full rounded mr-7 text-center text-xl">
                                    {sprint.sprintStatus}
                                </div>
                            </div>

                            {/* Save and Discard Button */}
                            <div className="flex justify-around my-4">
                                <button
                                    className="bg-[#616675] text-center px-2 py-1 rounded-lg text-xl"
                                    onClick={() => closeModal()}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SprintDetails;
